import { action, computed, makeObservable, observable, reaction } from 'mobx';

class Filter {
    filters = {
        problems: null,
        cities: null,
        districts: null,
        workingWithPairs: null,
        workingOffline: false
    };
    name = null;

    constructor(model) {
        makeObservable(this, {
            model: false,
            problemsOptions: computed,
            citiesOptions: computed,
            districtsOptions: computed,
            filters: observable,
            filtered: computed,
            workingWithPairsOptions: computed,
            workingOfflineOptions: computed,
            setFilter: action.bound,
            name: observable,
            setName: action.bound,
            resetFilters: action.bound
        })
        this.model = model;
        this.specialists = this.model.specialist.teasers;

        reaction(() => this.model.specialist.teasers,
            () => {
                this.specialists = this.model.specialist.teasers;
                this.resetFilters();
            }
        )

        reaction(() => this.filters.workingOffline,
            () => {
                this.setFilter('cities', null);
                this.setFilter('districts', null);
                this.applyFilters(this.filters);
            })
    }

    setName(name) {
        this.name = name;
    }

    setFilter(key, value) {
        this.setName(null);
        if (this.filters[key] === undefined) {
            console.warn(`unknown filter key: ${key}`);
        }
        if (value === null) {
            this.filters[key] = null;
        } else {
            this.filters[key] = value;
        }
    }

    resetFilters() {
        this.filters = {
            problems: null,
            cities: null,
            districts: null,
            workingWithPairs: null,
            workingOffline: false
        };
        this.name = null;
    }

    applyFilters(filters) {
        const predicate = (a, b) => ( a === b || a === b.id || a === b[0] )
        const keys = Object.keys(filters);
        return this.specialists.filter((spec) => {
            return keys.every(key => {
                if (filters[key] === null) return true;
                if (key === 'workingOffline') {
                    if (filters[key] === true) {
                        return spec.offlineCount > 0
                    }
                    if (filters[key] === false) {
                        return spec.onlineCount > 0
                    }
                }
                const specProp = spec[key] instanceof Map ? Array.from(spec[key]) : spec[key];
                if (Array.isArray(specProp)) {
                    return specProp.some(specProp => {
                        return predicate(filters[key], specProp);
                    });
                }
                return predicate(filters[key], spec[key]);
            });
        });
    }

    get filtered() {
        console.log('apply');
        let filtered = this.applyFilters(this.filters);
        if (this.name) {
            filtered = filtered.filter(spec => spec.data.name === this.name);
        }
        // if (this.selectedEvent) {
        //     filtered = filtered.filter(spec => spec.openEvents.some( oe => oe.startDate === this.selectedEvent));
        // }
        return filtered;
    }

    get problemsOptions() {
        const problemsFilters = {...this.filters};
        problemsFilters.problems = null;
        const specialists = this.applyFilters(problemsFilters);
        return this.model.specialist.allProblems(specialists.map(spec => spec.id));
    }

    get citiesOptions() {
        const citiesFilters = {...this.filters};
        citiesFilters.cities = null;
        const specialists = this.applyFilters(citiesFilters);
        return this.model.specialist.allCities(specialists.map(spec => spec.id));
    }

    get districtsOptions() {
        const districtFilters = {...this.filters};
        if (!districtFilters.cities) { return new Map() }
        districtFilters.districts = null;
        const specialists = this.applyFilters(districtFilters);
        return this.model.specialist.allCityDistricts(specialists.map(spec => spec.id), districtFilters.cities);
    }

    get workingWithPairsOptions() {
        const workingWithPairsFilters = {...this.filters};
        workingWithPairsFilters.workingWithPairs = null;
        const specialists = this.applyFilters(workingWithPairsFilters);
        return [...new Set(specialists.map((spec) => spec.workingWithPairs))]
    }

    get workingOfflineOptions() {
        const workingOfflineFilters = {...this.filters};
        workingOfflineFilters.workingOffline = null;
        const specialists = this.applyFilters(workingOfflineFilters);
        return [...new Set(specialists.map(spec => spec.serviceOptions).flat())];
    }

    get names() {
        return this.filtered.map(spec => spec.name);
    }

}

export default Filter;
